import { render, staticRenderFns } from "./biography-correction-index.vue?vue&type=template&id=616a2046&"
import script from "./biography-correction-index.vue?vue&type=script&lang=js&"
export * from "./biography-correction-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports